import {Component, Inject} from 'ng-metadata/core';

@Component({
    "selector": "prm-brief-result-delivery-option-link",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/briefResultDeliveryOptionLink/briefResultDeliveryOptionLink.html'
})

export class PrmBriefResultDeliveryOptionLink{

    constructor (@Inject('availabilityLineIcons') private availabilityLineIcons){       
    }

    ngOnInit(){
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/briefResultDeliveryOptionLink/briefResultDeliveryOptionLink.directive.ts